// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falTableList: CreateIconOptions = {
  "displayName": "FALTableList",
  "viewBox": "0, 0, 512, 512",
  "d": "M192 64l0 96 288 0 0-64c0-17.7-14.3-32-32-32L192 64zm-32 0L64 64C46.3 64 32 78.3 32 96l0 64 128 0 0-96zM32 192l0 128 128 0 0-128L32 192zm0 160l0 64c0 17.7 14.3 32 32 32l96 0 0-96L32 352zm160 96l256 0c17.7 0 32-14.3 32-32l0-64-288 0 0 96zM480 320l0-128-288 0 0 128 288 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"
};
